import React, { createContext, useState } from "react";
import RateLimitAlert from "../components/RateLimitAlert";

// Create the context
export const RateLimitAlertContext = createContext();

// Create the provider component
export const RateLimitAlertProvider = ({ children }) => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [limit, setLimit] = useState(180); // Default limit
  const [remaining, setRemaining] = useState(0); // Default remaining requests

  // Function to open the alert with rate limit details
  const openAlert = (limit = 180, remaining = 0) => {
    setLimit(limit);
    setRemaining(remaining);
    setIsAlertOpen(true);
  };

  // Function to close the alert
  const closeAlert = () => {
    setIsAlertOpen(false);
  };

  return (
    <RateLimitAlertContext.Provider value={{ 
        isAlertOpen, 
        openAlert, 
        closeAlert 
        }}>
      {children}
      {isAlertOpen && <RateLimitAlert limit={limit} remaining={remaining} onClose={closeAlert} />}
    </RateLimitAlertContext.Provider>
  );
};
